var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',[_c('v-card-title',[_c('h2',[_vm._v(" Recon Files ")])]),_c('v-card-text',[_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.getReport}},[_vm._v("Download")])],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }